module.exports = __webpack_public_path__ + "static/media/SFP_white.4345f2a5.png";